module.exports = require('./helpers/bundle-url').getBundleURL('01DWS') + "SM001_CREATIVE_ASSETS_2.2bea465e.png";